import gql from 'graphql-tag';

export default gql`
mutation UPDATE_BATCH_IS_READ_TAB_NOTIFICATION($companyKsuid: String!) {
  readAllInAppNotifications(companyKsuid: $companyKsuid)
}
`;
